import React, { useContext, useCallback } from 'react'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import Group from 'components/utils/Group'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import MarkdownRender from 'LuxKit/MarkdownRender'
import ContactContext from 'contexts/contactContext'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  termsAndConditions: string
  onViewOffers: () => void
}

function CruiseDealTermsConditionsModal({ termsAndConditions, onViewOffers }: Props) {
  const intl = useIntl()
  const supportContact = useContext(ContactContext)
  const elementContext = useModalElementContext()

  const handleViewOffers = useCallback(() => {
    onViewOffers()
    elementContext?.resolve()
  }, [elementContext, onViewOffers])

  return <ModalBase size="L">
    <ModalHeader title={intl.formatMessage({
      id: 'lTQX4lbwE2',
      defaultMessage: 'Terms and Conditions',
      description: 'Modal title for cruise deal terms and conditions',
    })}
    />
    <ModalBody>
      <ModalContent>
        <BodyText variant="medium">
          <MarkdownRender content={termsAndConditions} />
        </BodyText>
      </ModalContent>
    </ModalBody>
    <ModalFooter>
      <Group
        direction="vertical-reverse"
        tabletDirection="horizontal"
        horizontalAlign="stretch"
        tabletHorizontalAlign="end"
        gap={16}
      >
        <TextButton
          kind="tertiary"
          size="large"
          startIcon={<LinePhoneIcon />}
          href={`tel:${supportContact.local.number}`}
          fit="mobile-full-width"
        >
          {intl.formatMessage({
            id: '5tFQ303TFI',
            defaultMessage: 'Call {phoneNumber}',
            description: 'Button text to call support with phone number',
          }, { phoneNumber: supportContact.local.humanReadable })}
        </TextButton>

        <TextButton
          kind="primary"
          size="large"
          onClick={handleViewOffers}
          fit="mobile-full-width"
        >
          {intl.formatMessage({
            id: 'kvjv0EjTDv',
            defaultMessage: 'View Offers',
            description: 'Button text to view cruise offers',
          })}
        </TextButton>
      </Group>
    </ModalFooter>
  </ModalBase>
}

export default CruiseDealTermsConditionsModal
